// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** @deprecated: this file is about to be removed */
.n-table-cell {
  position: relative;
  padding: 0;
}
.n-table-cell--header {
  font-weight: 700;
  font-family: 'IBM Plex Sans';
  line-height: inherit;
}
.n-table-cell--align-left {
  text-align: left;
}
.n-table-cell--align-center {
  text-align: center;
}
.n-table-cell--align-right {
  text-align: right;
}
.n-table-content {
  word-wrap: break-word;
  word-break: break-all;
}
.n-table-content--with-padding {
  padding: 12px 10px;
}
.n-table-content--with-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}
.n-table-content--numeric {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/core-ui/components/table/TableCell/TableCell.less"],"names":[],"mappings":"AAAA,mDAAmD;AAGnD;EACE,kBAAA;EACA,UAAA;AADF;AAGE;EACE,gBAAA;EACA,4BAAA;EACA,oBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKE;EACE,kBAAA;AAHJ;AAME;EACE,iBAAA;AAJJ;AAUA;EACE,qBAAA;EACA,qBAAA;AARF;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AATJ;AAYE;EACE,iBAAA;EACA,kCAAA;AAVJ","sourcesContent":["@import \"~neptune-core-ui/less/variables.less\";\n\n\n.n-table-cell {\n  position: relative;\n  padding: 0;\n\n  &--header {\n    font-weight: @font-weight-bold;\n    font-family: @IBMPlexSans;\n    line-height: inherit;\n  }\n\n  &--align-left {\n    text-align: left;\n  }\n\n  &--align-center {\n    text-align: center;\n  }\n\n  &--align-right {\n    text-align: right;\n  }\n}\n\n\n// Common styles for renderers\n.n-table-content {\n  word-wrap:break-word;\n  word-break:break-all;\n\n  &--with-padding {\n    padding: @TableCell-padding;\n  }\n\n  &--with-actions {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n  }\n\n  &--numeric {\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
